export const T = {
  en_GB: {
    name: "Name",
    companyName: "Company Name",
    country: "Country",
    organizationNumber: "Organization Number",
    orgIdPlaceholder: "e.g., 915383416",
    runSearch: "Run Search",
    companySection: "Company",
    companyChecked: "— checked against sanction lists only",
    groupSection: "Group",
    groupChecked: "— not screened; the group has no identity of its own",
    groupName: "Group name",
    representativeSaved:
      "Registered under Related parties when the client has no representative yet; once it has, each person must be one of them (edit them under Related parties, not here).",
    addRepresentative: "Add representative",
    representativeLimit: (max: number) => `A client can have at most ${max} representatives.`,
    optionalImproves: "Optional - improves search accuracy",
    fullName: "Full name",
    incompleteMessage: "Run the Trapets lookup",
  },
  nb_NO: {
    name: "Navn",
    companyName: "Firmanavn",
    country: "Land",
    organizationNumber: "Organisasjonsnummer",
    orgIdPlaceholder: "f.eks. 915383416",
    runSearch: "Kjør søk",
    companySection: "Selskap",
    companyChecked: "— sjekkes kun mot sanksjonslister",
    groupSection: "Gruppe",
    groupChecked: "— sjekkes ikke; gruppen har ingen egen identitet",
    groupName: "Gruppenavn",
    representativeSaved:
      "Registreres under Relaterte parter når kunden ikke har noen representant ennå; har kunden representanter, må hver person være en av dem (rediger dem under Relaterte parter, ikke her).",
    addRepresentative: "Legg til representant",
    representativeLimit: (max: number) => `En klient kan ha høyst ${max} representanter.`,
    optionalImproves: "Valgfritt - forbedrer søkepresisjon",
    fullName: "Fullt navn",
    incompleteMessage: "Kjør Trapets-oppslaget",
  },
} as const;
